import React from 'react';

import {isNil, get} from 'lodash-es';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import {getUserProperties} from 'static/three-oh/src/modules/selectors/userSelectors';

const propTypes = {
  location: PropTypes.object,
  userId: PropTypes.number,
  userProperties: PropTypes.object,
};

/**
 * Appcues Tracking - Initializes Appcues tracking by identifying user id and user properties
 */
class AppcuesTracking extends React.Component {
  componentDidUpdate(prevProps) {
    const {location: {pathname}} = this.props;
    const previousLocation = prevProps.location.pathname;
    if (pathname !== previousLocation) {
      // https://studio.appcues.com/settings/installation/guide/page
      window.Appcues && window.Appcues.page();
    }
  }

  initializeAppcues = () => {
    try {
      const {userId, userProperties} = this.props;
      window.Appcues.identify(userId, userProperties);
    } catch (error) {
      // Ignore complaints about being tracked.
    }
  }

  render() {
    const {userId, userProperties} = this.props;

    if (!isNil(userId) && userProperties.isTeacher) {
      this.initializeAppcues();
      return null;
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  const user = get(state, 'user', null);
  const userId = get(user, 'id');
  const userProperties = getUserProperties(state);

  return {
    userId,
    userProperties,
  };
};

AppcuesTracking.propTypes = propTypes;
const AppcuesTrackingContainer = connect(mapStateToProps, {})(AppcuesTracking);
export default withRouter(AppcuesTrackingContainer);
